const pendoInstallation = () => {
  (function (apiKey) {
    (function (p, e, n, d: any) {
      var v: string[], o: any, w, x, y, z;
      o = p[d] = p[d] || {};
      o._q = o._q || [];

      v = ["initialize", "identify", "updateOptions", "pageLoad", "track"];
      for (w = 0, x = v.length; w < x; ++w)
        (function (m) {
          o[m] =
            o[m] ||
            function () {
              o._q[m === v[0] ? "unshift" : "push"](
                [m].concat([].slice.call(arguments, 0))
              );
            };
        })(v[w]);

      y = e.createElement(n) as HTMLScriptElement;
      y.async = !0;
      y.src = "https://cdn.pendo.io/agent/static/" + apiKey + "/pendo.js";

      z = e.getElementsByTagName(n)[0];
      if (z.parentNode) z.parentNode.insertBefore(y, z);
    })(window, document, "script", "pendo");
  })("69e71581-c95c-45bf-603b-12d31d57c4f3");
};

export default pendoInstallation;
